/**
 * Erros HTTP conhecidos pelo transporte.
 *
 * Respostas 4xx (exceto os casos transitórios) representam uma requisição
 * inválida para a API, não indisponibilidade do transporte. Repeti-las abre o
 * circuit breaker e acaba escondendo eventos seguintes na aba Network.
 */
export class HttpResponseError extends Error {
  readonly status: number;

  readonly retryable: boolean;

  readonly shouldTripCircuitBreaker: boolean;

  constructor(status: number) {
    super(`[HttpSender] HTTP ${status}`);
    this.name = 'HttpResponseError';
    this.status = status;
    this.retryable =
      status === 408 || status === 425 || status === 429 || status >= 500;
    this.shouldTripCircuitBreaker = status >= 500;
  }
}

export function isRetryableTransportError(error: unknown): boolean {
  return !(error instanceof HttpResponseError) || error.retryable;
}

export function shouldTripCircuitBreaker(error: unknown): boolean {
  return (
    !(error instanceof HttpResponseError) || error.shouldTripCircuitBreaker
  );
}
